<div>
  <dx-data-grid class="h-100"
                (onToolbarPreparing)="onGridToolbarPreparing($event)"
                [dataSource]="workflowPlans"
                keyExpr="id"
                [allowColumnResizing]="true"
                [customizeColumns]="customizeColumns"
                [editing]="{
                  allowUpdating: true,
                  allowDeleting: true,
                  mode: 'cell'
                }"
                (onRowRemoving)="deleteWorkflowplan($event)"
                noDataText="{{ 'keine Workflowpläne vorhanden' | translate }}"
                [showBorders]="true">

    <div *dxTemplate="let toolbaritem of 'newWorkflowPlanButtonTemplate'">
      <dx-button stylingMode="text" type="default" text="{{ 'Neuen Workflowplan anlegen' | translate }}" (onClick)="createNewWorkflowPlan()" hint="{{ 'Neuen Workflowplan anlegen' | translate }}"></dx-button>
    </div>
    <dxi-column dataField="workflowId" caption="{{ 'Workflow' | translate }}" cellTemplate="workflowTemplate" editCellTemplate="workflowTemplate"></dxi-column>
    <dxi-column [calculateCellValue]="getAppointmentString" caption="{{ 'Zeitplan' | translate}}" [allowEditing]="false"></dxi-column>
    <dxi-column [calculateCellValue]="getLastRunValue" caption="{{ 'Letzte Ausführung' | translate }}" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="executionCounter" caption="{{ 'Ausführungen' | translate }}" [allowEditing]="false"></dxi-column>
   <dxi-column editCellTemplate="diffCellTemplate">
      <div *dxTemplate="let data of 'diffCellTemplate'">
        <dx-button style="text-align: right; float: right;" text="{{'Manuell ausführen'|translate}}" (onClick)="run(data)" icon="redo">
        </dx-button>
      </div>
    </dxi-column>
   <dxi-column type="buttons">
     <dxi-button text="{{ 'Zeitplan' | translate }}"
                 icon="clock"
                 [onClick]="createUpdateDeleteWorkflowPlan">
     </dxi-button>
     <dxi-button name="delete">
     </dxi-button>
   </dxi-column>

    <div *dxTemplate="let column of 'workflowTemplate'">
      <dx-select-box [items]="workflows"
                     [(value)]="column.data.workflowId"
                     displayExpr="name"
                     valueExpr="id"
                     (onValueChanged)="updateWorkflowId($event, column.data)">
      </dx-select-box>
    </div>

  </dx-data-grid>

  <dx-popup [(visible)]="schedulerVisible"
            contentTemplate="popupContent"
            [hideOnOutsideClick]="true"
            [showCloseButton]="true"
            (onShown)="handlePopupShown()">
    <div *dxTemplate="let data of 'popupContent'">
      <dx-scheduler #workflowPlanScheduler
                    [dataSource]="appointmentData"
                    [timeZone]="'UTC'"
                    [views]="['month']"
                    currentView="month"
                    [startDayHour]="9"
                    [height]="730"
                    (onAppointmentAdded)="onAppointmentAdded($event)"
                    (onAppointmentDeleted)="onAppointmentDeleted($event)"
                    (onAppointmentUpdated)="onAppointmentUpdated($event)"                    
                    (onAppointmentFormOpening)="onAppointmentFormOpening($event)">
      </dx-scheduler>
    </div>
  </dx-popup>

</div>
